import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const InstructorNotesIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M5.5 4.00049V1.3335C5.5 1.05735 5.72386 0.833496 6 0.833496C6.27614 0.833496 6.5 1.05735 6.5 1.3335V4.00049C6.49982 4.27648 6.27603 4.50049 6 4.50049C5.72397 4.50049 5.50018 4.27648 5.5 4.00049Z"
      fill="currentColor"
    />
    <path
      d="M9.5 4.00049V1.3335C9.5 1.05735 9.72386 0.833496 10 0.833496C10.2761 0.833496 10.5 1.05735 10.5 1.3335V4.00049C10.4998 4.27648 10.276 4.50049 10 4.50049C9.72397 4.50049 9.50018 4.27648 9.5 4.00049Z"
      fill="currentColor"
    />
    <path
      d="M12.8336 3.99966C12.8335 3.53958 12.4598 3.16666 11.9997 3.16666H3.99966C3.53969 3.16683 3.16683 3.53969 3.16666 3.99966V13.3336C3.16683 13.7936 3.53969 14.1665 3.99966 14.1667H11.9997C12.4598 14.1667 12.8335 13.7937 12.8336 13.3336V3.99966ZM13.8336 13.3336C13.8335 14.346 13.0121 15.1667 11.9997 15.1667H3.99966C2.9874 15.1665 2.16683 14.3459 2.16666 13.3336V3.99966C2.16683 2.9874 2.9874 2.16683 3.99966 2.16666H11.9997C13.0121 2.16666 13.8335 2.98729 13.8336 3.99966V13.3336Z"
      fill="currentColor"
    />
    <path
      d="M10.6664 7.5C10.9425 7.5 11.1664 7.72386 11.1664 8C11.1664 8.27614 10.9425 8.5 10.6664 8.5H5.33337C5.05723 8.5 4.83337 8.27614 4.83337 8C4.83337 7.72386 5.05723 7.5 5.33337 7.5H10.6664Z"
      fill="currentColor"
    />
    <path
      d="M8.66638 10.5C8.94252 10.5 9.16638 10.7239 9.16638 11C9.16638 11.2761 8.94252 11.5 8.66638 11.5H5.33337C5.05723 11.5 4.83337 11.2761 4.83337 11C4.83337 10.7239 5.05723 10.5 5.33337 10.5H8.66638Z"
      fill="currentColor"
    />
  </svg>
);
